import * as Yup from "yup";


/***************************************************************
 * テナント一覧
 **************************************************************/
/**
 * テナント情報一覧取得API リクエスト
 */
export class TenantSearchRequest {
  /** テナントID */
  public id: string = "";
  /** 公開コード */
  public disclosureCode: string = "";
  /** テナント名 */
  public tenantName: string = "";
  /** 親テナント名 */
  public parentName: string = "";
  /** 上位操作 */
  public upperOperation: string = "";
  /** 会社名 */
  public companyName: string = "";
  /** 営業担当者名 */
  public salesRepresentativeName: string = "";
  /** テナントステータス */
  public tenantStatus: string = "";
  /** 契約日 */
  public tenantContractDate: string = "";
  /** 契約日の検索タイプ */
  public tenantContractDateOption: string = "0";
  /** 削除フラグ */
  public isDeleted?: boolean = false;
}
/**
 * テナント情報一覧取得API レスポンス
 */
export class TenantSearchResponse {
  /** テナントID */
  public id: string = "";
  /** 公開コード */
  public disclosureCode: string = "";
  /** テナント名 */
  public tenantName: string = "";
  /** 親テナント名 */
  public parentName: string = "";
  /** 上位操作 */
  public upperOperation: string = "";
  /** 会社名 */
  public companyName: string = "";
  /** 営業担当者名 */
  public salesRepresentativeName: string = "";
  /** テナントステータス */
  public tenantStatus: string = "";
  /** 契約開始日 */
  public contractStart: string = "";
  /** 契約終了日 */
  public contractEnd: string = "";
  /** テナント削除日 */
  public deleteDate: string = "";
}

/***************************************************************
 * テナント詳細
 **************************************************************/
/**
 * テナント情報詳細取得API リクエスト
 */
export class TenantDetailRequest {
  /** テナントID */
  public id: string = "";
}

/**
 * テナント情報詳細取得API レスポンス
 */
export class TenantDetailResponse {
  /** テナントID */
  public id: string = "";
  /** テナント名 */
  public tenantName: string = "";
  /** 公開コード */
  public disclosureCode: string = "";
  /** 親テナントID */
  public parentId: string = "";
  /** 親テナント名 */
  public parentName: string = "";
  /** 上位操作 */
  public upperOperation: string = "";
  /** 企業ID */
  public companyId: string = "";
  /** 企業名 */
  public companyName: string = "";
  /** 基本情報 */
  public basicInformation: string = "";
  /** 管理者ID */
  public administratorId: string = "";
  /** 管理者名 */
  public administratorName: string = "";
  /** 責任者ID */
  public responsibleId: string = "";
  /** 責任者名 */
  public responsibleName: string = "";
  /** 営業担当者名 */
  public salesRepresentativeName: string = "";
  /** テナントステータス */
  public tenantStatus: string = "";
  /** テナント開設料 */
  public contractChargePrice: string = "";
  /** 契約開始日 */
  public contractStart: string = "";
  /** 契約終了日 */
  public contractEnd: string = "";
  /** 契約最大MDMアカウント数 */
  public contractMaxAccount: string = "";
  /** MFA認証実施可否 */
  public isMfaauth: string = "";
  /** 契約条件（前払い必須） */
  public isMaebarai: string = "";
  /** 備考 */
  public comment: string = "";
  /** 作成者 */
  public createUser: string = "";
  /** 作成日時 */
  public createDate: string = "";
  /** 更新者 */
  public updateUser: string = "";
  /** 更新日時 */
  public updateDate: string = "";
  /** 削除日時 */
  public deleteDate: string = "";
}

/***************************************************************
 * テナント追加/編集
 **************************************************************/

/**
 * エラーメッセージ
 */
export const ERR_MESSAGE = {
  tenantNameIsNull: "テナント名を入力してください。",
  companyIdIsNull: "企業名を入力してください。",
  // basicInformationIsNull: "基本情報を入力してください。",
  salesRepresentativeNameIsNull: "営業担当者名を入力してください。",
  startViewIsNull: "契約期間（開始日）を選択してください。",
  isMfaauthIsNull: "MFA認証実施可否を選択してください。",
};


/**
 * バリデーションルール
 */
export const TenantCreateFormSchema = Yup.object({
  tenantName: Yup.string().required(ERR_MESSAGE.tenantNameIsNull),
  companyId: Yup.string().required(ERR_MESSAGE.companyIdIsNull),
  // basicInformation: Yup.string().required(ERR_MESSAGE.basicInformationIsNull),
  salesRepresentativeName: Yup.string().required(ERR_MESSAGE.salesRepresentativeNameIsNull),
  startView: Yup.date().required(ERR_MESSAGE.startViewIsNull),
  isMfaauth: Yup.string().required(ERR_MESSAGE.isMfaauthIsNull),
});
export const TenantEditFormSchema = Yup.object({
  tenantName: Yup.string().required(ERR_MESSAGE.tenantNameIsNull),
  companyId: Yup.string().required(ERR_MESSAGE.companyIdIsNull),
  // basicInformation: Yup.string().required(ERR_MESSAGE.basicInformationIsNull),
  salesRepresentativeName: Yup.string().required(ERR_MESSAGE.salesRepresentativeNameIsNull),
  startView: Yup.date().required(ERR_MESSAGE.startViewIsNull),
  isMfaauth: Yup.string().required(ERR_MESSAGE.isMfaauthIsNull),
});

/**
 * テナント情報新規作成・編集フォーム(入力チェック用)
 */
export class TenantEditForm {
  /** テナントID */
  public id: string = "";
  /** 公開コード */
  public disclosureCode: string = "";
  /** テナント名 */
  public tenantName: string = "";
  /** 親テナントID */
  public parentId: string = "";
  /** 上位操作 */
  public upperOperation: string = "";
  /** 企業ID */
  public companyId: string = "";
  /** 企業名 */
  public companyName: string = "";
  /** 基本情報 */
  public basicInformation: string = "";
  /** 管理者ID */
  public administratorId: string = "";
  /** 管理者名 */
  public administratorName: string = "";
  /** 責任者ID */
  public responsibleId: string = "";
  /** 責任者名 */
  public responsibleName: string = "";
  /** 営業担当者名 */
  public salesRepresentativeName: string = "";
  /** テナントステータス */
  public tenantStatus: string = "";
  /** テナント開設料 */
  public contractChargePrice: string = "";
  /** 契約期間（開始日） */
  public startView: Date = new Date();
  /** 契約期間（終了日） */
  public endView: Date = new Date();
  /** 契約期間（開始日） */
  public contractStart: string = "";
  /** 契約期間（終了日） */
  public contractEnd: string = "";
  /** 契約最大MDMアカウント数 */
  public contractMaxAccount: string = "";
  /** MFA認証実施可否 */
  public isMfaauth: string = "";
  /** 契約条件（前払い必須） */
  public isMaebarai: string = "";
  /** 備考 */
  public comment: string = "";
  /** 作成者 */
  public createUser: string = "";
  /** 作成日時 */
  public createDate: string = "";
  /** 更新者 */
  public updateUser: string = "";
  /** 更新日時 */
  public updateDate: string = "";
  /** 削除日時 */
  public deleteDate: string = "";
}

/**
 * テナント情報新規作成リクエスト
 */
export class TenantCreateRequest {
  createdata: TenantEditForm = new TenantEditForm();
}

/**
 * テナント情報編集リクエスト
 */
export class TenantEditRequest {
  editdata: TenantEditForm = new TenantEditForm();
}


/***************************************************************
 * 他箇所との連携用
 **************************************************************/
/**
 * テナント情報（ID、テナント名、会社名）取得API リクエスト
 */
export class TenantNameRequest {
  /** テナントID */
  public id: string = "";
}
/**
 * テナント情報（ID、テナント名、会社名）取得API レスポンス
 */
export class TenantNameResponse {
  /** テナントID */
  public id: string = "";
  /** テナント名 */
  public tenantName: string = "";
  /** 会社名 */
  public companyName: string = "";
}